import * as yup from 'yup'
import { ImageSchema } from '../media/Image.schema'
import { createDataRef, createDataSchema } from '../schemaUtils'

export const ImageListDataSchema = createDataSchema(
	'ImageList',
	yup.object({
		items: yup.array(createDataRef({ Image: ImageSchema })),
	})
)
